module.exports = __webpack_public_path__ + "img/Tecnicas_de_Coleta_de_Sangue.bf24e9ce.jpg";